export default function AhaEffects() {
  const effects = [
    {
      icon: "ri-lightbulb-flash-line",
      title: "Von Überforderung zu Klarheit",
      before: "Ich weiß nicht, wo ich anfangen soll...",
      after: "Ich habe einen klaren Plan und weiß genau, was als nächstes zu tun ist",
      color: "from-teal-400 to-cyan-500",
      image: "https://public.readdy.ai/ai/img_res/00df7ef07c10be024def108c9dd35317.jpg"
    },
    {
      icon: "ri-emotion-happy-line",
      title: "Von Selbstzweifeln zu Selbstvertrauen",
      before: "Ich schaffe das sowieso nicht...",
      after: "Ich erkenne meine Stärken und gehe selbstbewusst meinen Weg",
      color: "from-cyan-400 to-teal-500",
      image: "https://readdy.ai/api/search-image?query=confident%20person%20standing%20tall%20with%20proud%20smile%20and%20open%20body%20language%20bright%20modern%20environment%20with%20teal%20turquoise%20color%20accents%20natural%20light%20self-assured%20expression%20looking%20forward%20with%20determination%20personal%20empowerment%20moment%20inspiring%20atmosphere%20lifestyle%20photography%20professional%20warm%20lighting&width=600&height=400&seq=aha-confidence-person&orientation=landscape"
    },
    {
      icon: "ri-compass-3-line",
      title: "Von Ziellosigkeit zu Fokus",
      before: "Ich verliere mich in zu vielen Dingen...",
      after: "Ich konzentriere mich auf das Wesentliche und erreiche meine Ziele",
      color: "from-teal-500 to-emerald-500",
      image: "https://readdy.ai/api/search-image?query=focused%20person%20working%20intently%20on%20single%20task%20with%20concentrated%20expression%20modern%20bright%20workspace%20with%20teal%20turquoise%20elements%20minimal%20distractions%20clean%20organized%20environment%20determination%20and%20focus%20moment%20natural%20daylight%20peaceful%20productive%20atmosphere%20lifestyle%20photography%20soft%20warm%20lighting&width=600&height=400&seq=aha-focus-person&orientation=landscape"
    },
    {
      icon: "ri-mental-health-line",
      title: "Von Stress zu innerer Ruhe",
      before: "Alles ist zu viel, ich bin erschöpft...",
      after: "Ich habe Strategien, um mit Stress umzugehen und finde Balance",
      color: "from-emerald-400 to-teal-500",
      image: "https://readdy.ai/api/search-image?query=peaceful%20person%20relaxing%20in%20comfortable%20space%20with%20serene%20calm%20expression%20eyes%20closed%20or%20looking%20peacefully%20ahead%20cozy%20environment%20with%20teal%20turquoise%20cushions%20and%20soft%20textiles%20natural%20light%20streaming%20in%20plants%20around%20inner%20peace%20and%20balance%20moment%20wellness%20lifestyle%20photography%20warm%20gentle%20lighting&width=600&height=400&seq=aha-peace-person&orientation=landscape"
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white via-teal-50/30 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-teal-100 text-teal-700 px-6 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-sparkling-2-line mr-2"></i>
            Echte Transformationen
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Was du mit Mindshift AI erreichen kannst
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Erlebe, wie andere Menschen durch Mindshift AI ihre größten Herausforderungen 
            gemeistert haben – und wie auch du es schaffen kannst.
          </p>
        </div>

        <div className="space-y-16">
          {effects.map((effect, index) => (
            <div 
              key={index} 
              className={`grid lg:grid-cols-2 gap-8 items-center ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              {/* Image */}
              <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                <div className="relative rounded-2xl overflow-hidden shadow-2xl group">
                  <div className="w-full h-80">
                    <img 
                      src={effect.image}
                      alt={effect.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className={`absolute top-4 right-4 w-16 h-16 bg-gradient-to-br ${effect.color} rounded-full flex items-center justify-center shadow-lg`}>
                    <i className={`${effect.icon} text-2xl text-white`}></i>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                <h3 className="text-3xl font-bold text-gray-900 mb-6">
                  {effect.title}
                </h3>

                {/* Before */}
                <div className="bg-red-50 border-l-4 border-red-400 rounded-lg p-6 mb-4">
                  <div className="flex items-start">
                    <div className="flex-shrink-0">
                      <i className="ri-close-circle-line text-2xl text-red-500"></i>
                    </div>
                    <div className="ml-4">
                      <p className="text-sm font-semibold text-red-800 mb-1">Vorher</p>
                      <p className="text-gray-700 italic">"{effect.before}"</p>
                    </div>
                  </div>
                </div>

                {/* Arrow */}
                <div className="flex justify-center my-4">
                  <i className="ri-arrow-down-line text-3xl text-teal-500"></i>
                </div>

                {/* After */}
                <div className="bg-teal-50 border-l-4 border-teal-500 rounded-lg p-6">
                  <div className="flex items-start">
                    <div className="flex-shrink-0">
                      <i className="ri-checkbox-circle-line text-2xl text-teal-600"></i>
                    </div>
                    <div className="ml-4">
                      <p className="text-sm font-semibold text-teal-800 mb-1">Nachher</p>
                      <p className="text-gray-700 font-medium">"{effect.after}"</p>
                    </div>
                  </div>
                </div>

                {/* Stats */}
                <div className="mt-6 flex items-center text-sm text-gray-600">
                  <i className="ri-time-line mr-2 text-teal-600"></i>
                  <span>Durchschnittlich nach 2-3 Wochen regelmäßiger Nutzung</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-teal-500 to-cyan-600 rounded-2xl p-8 lg:p-12 shadow-2xl">
            <h3 className="text-3xl font-bold text-white mb-4">
              Bereit für deinen eigenen Aha-Moment?
            </h3>
            <p className="text-xl text-teal-50 mb-8 max-w-2xl mx-auto">
              Starte jetzt deine 7-tägige kostenlose Testphase und erlebe selbst, 
              wie Mindshift AI dein Leben verändern kann.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="https://t.me/mindshift_ai_bot"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white text-teal-600 px-8 py-4 rounded-full hover:bg-gray-100 transition-all text-lg font-semibold shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center justify-center"
              >
                <i className="ri-telegram-line mr-2 text-xl"></i>
                Telegram Bot starten
              </a>
              <a
                href="/dashboard"
                className="bg-teal-700 text-white px-8 py-4 rounded-full hover:bg-teal-800 transition-all text-lg font-semibold shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center justify-center border-2 border-white"
              >
                <i className="ri-dashboard-line mr-2 text-xl"></i>
                Web-App öffnen
              </a>
            </div>
            <p className="mt-6 text-teal-100 text-sm">
              <i className="ri-shield-check-line mr-2"></i>
              100% vertraulich • DSGVO-konform • In Deutschland gehostet
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
